import { axiosInstancePrivateServicesFluxiUrl } from "@/services/instance";

export interface UpdateEmailResponse {
  access_token: string;
  refresh_token: string;
  token_type?: string;
  expires_in?: number;
  username?: string;
  roles?: string[];
}

export const userEmailService = {
  async update(email: string): Promise<UpdateEmailResponse> {
    const response = await axiosInstancePrivateServicesFluxiUrl.put(
      `/api/ms/ecommerce-service/user/email`,
      { email }
    );
    return response.data as UpdateEmailResponse;
  },
};


